<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="
      M1.9306 2.45521C1.7998 2.71191 1.7998 3.04794 1.7998 3.72V5.88C1.7998
      6.55206 1.7998 6.88809 1.9306 7.14479C2.04564 7.37058 2.22922 7.55416
      2.45502 7.66921C2.71171 7.8 3.04774 7.8 3.7198 7.8H4.2V6.12C4.2 5.44794
      4.2 5.11191 4.33079 4.85521C4.44584 4.62942 4.62942 4.44584 4.85521 4.33079C5.11191
      4.2 5.44794 4.2 6.12 4.2H7.7998V3.72C7.7998 3.04794 7.7998 2.71191 7.66901
      2.45521C7.55396 2.22942 7.37039 2.04584 7.14459 1.93079C6.8879 1.8 6.55187
      1.8 5.8798 1.8H3.7198C3.04774 1.8 2.71171 1.8 2.45502 1.93079C2.22922 2.04584
      2.04564 2.22942 1.9306 2.45521Z
      "
      fill="var(--color-icon-default)"
      fill-opacity="0.24"
    />
    <path
      d="
      M7.7998 4.2V3.72C7.7998 3.04794 7.7998 2.71191 7.66901 2.45521C7.55396 2.22942
      7.37039 2.04584 7.14459 1.93079C6.8879 1.8 6.55187 1.8 5.8798 1.8H3.7198C3.04774
      1.8 2.71171 1.8 2.45502 1.93079C2.22922 2.04584 2.04564 2.22942 1.9306 2.45521C1.7998
      2.71191 1.7998 3.04794 1.7998 3.72V5.88C1.7998 6.55206 1.7998 6.88809 1.9306
      7.14479C2.04564 7.37058 2.22922 7.55416 2.45502 7.66921C2.71171 7.8 3.04774
      7.8 3.7198 7.8H4.1998
      "
      stroke="var(--color-icon-subtle)"
      stroke-width="0.9"
      stroke-linecap="round"
    />
    <rect
      x="4.2002"
      y="4.2"
      width="6"
      height="6"
      rx="1.2"
      stroke="var(--color-icon-subtle)"
      stroke-width="0.9"
      stroke-linecap="round"
    />
  </svg>
</template>
